'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { v4 as uuid } from 'uuid';
import { useAnalyticsPageView } from '../components/PageView/Context';
import { getCleanLocationHref } from '../lib/urlUtils';
import { EventName } from '../Shibuya';
import { useAnalytics } from './useAnalytics';
type TrackElementInteractedParams = {
  entityName: string;
  interactionType: string;
  sectionName?: string;
  parentEventId?: string;
  itemCopy?: string;
  additionalAttributes?: Record<string, unknown>;
};
export function useTrackElementInteracted() {
  const $ = _c(7);
  const {
    analytics,
    deployableName,
    deployableVersion,
    gitSha
  } = useAnalytics();
  const {
    pageName,
    pageViewId
  } = useAnalyticsPageView();
  let t0;
  if ($[0] !== analytics || $[1] !== deployableName || $[2] !== deployableVersion || $[3] !== gitSha || $[4] !== pageName || $[5] !== pageViewId) {
    t0 = t1 => {
      const {
        entityName,
        interactionType,
        sectionName,
        parentEventId,
        itemCopy,
        additionalAttributes
      } = t1;
      const eventId = uuid();
      analytics.track(EventName.ELEMENT_INTERACTED, {
        entity_name: entityName,
        interaction_type: interactionType,
        event_id: eventId,
        page_name: pageName,
        page_url: getCleanLocationHref(),
        pageview_id: pageViewId,
        deployable_name: deployableName,
        deployable_version: deployableVersion,
        ...(sectionName && {
          section_name: sectionName
        }),
        ...(parentEventId && {
          parent_event_id: parentEventId
        }),
        ...(itemCopy && {
          item_copy: itemCopy
        }),
        ...(additionalAttributes && {
          additional_attributes: additionalAttributes
        })
      }, {
        context: {
          app: {
            name: deployableName,
            version: gitSha
          }
        }
      });
      return eventId;
    };
    $[0] = analytics;
    $[1] = deployableName;
    $[2] = deployableVersion;
    $[3] = gitSha;
    $[4] = pageName;
    $[5] = pageViewId;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
}